const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Production uses one Render service, so an unset backend URL means same-origin.
export const API_BASE = `${backendUrl}/api`;
